var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { color: "white" } }, [
    _vm._v(
      _vm._s(_vm.data && _vm.data[0] ? _vm.table_title : undefined) + "\n  "
    ),
    _c(
      "table",
      { attrs: { border: "1" } },
      [
        _vm.head && _vm.head.length > 0
          ? _c(
              "tr",
              _vm._l(_vm.head, function(item, idx) {
                return _c("th", { key: idx }, [
                  _vm._v("\n          " + _vm._s(item) + "\n          ")
                ])
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.data, function(row, r_idx) {
          return _c(
            "tr",
            {
              key: r_idx,
              style: { height: _vm.cell_width },
              attrs: { td_n: Array.isArray(row) ? row.length : 0 }
            },
            _vm._l(row, function(col, c_idx) {
              return _c(
                "td",
                {
                  key: c_idx,
                  style: _vm.v_style(col),
                  attrs: {
                    title: _vm.col_title(col, [r_idx, c_idx, row.length]),
                    colspan: _vm.col_span(col),
                    rowspan: _vm.row_span(col),
                    tips: _vm.col_tips(col)
                  },
                  on: {
                    mouseenter: function($event) {
                      return _vm.$emit("cellEnter", [col, r_idx, c_idx])
                    }
                  }
                },
                [
                  _c("input", {
                    ref: "r_idx + '_' + c_idx",
                    refInFor: true,
                    style: _vm.v_style2(col),
                    attrs: { readonly: _vm.editable ? "readonly" : false },
                    domProps: { value: _vm.col_value(col) }
                  })
                ]
              )
            }),
            0
          )
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }